<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editSpending') }}</h1>
      <div class="form-container">
        <SpendingForm @save="save"
                        :edit-mode="true"
                        :spending-data="spendingData">
        </SpendingForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import {mapState} from 'vuex'
  import DashboardLayout from '@/components/DashboardLayout'
  import SpendingForm from "@/components/SpendingForm";

  export default {
    components: {
      DashboardLayout,
      SpendingForm
    },
    methods: {
      save(form) {
        this.$store.dispatch('Spending/update', {
          spending: form,
          projectId: this.$route.params.projectId
        }).then(() => {
          this.$router.push({
            name: 'projectDetail',
            params: {
              projectId: this.$route.params.projectId,
              section: 'spending'
            }
          })
        })
      }
    },
    mounted() {
      this.$store.dispatch('Spending/getSpending', {
        projectId: this.$route.params.projectId,
        spendingId: this.$route.params.spendingId
      })
    },
    computed: {
      ...mapState('Spending', ['spending']),
      spendingData() {
        return {
          ...this.spending,
          date: new Date(this.spending.date),
          file: null
        }
      },
      breadcrumbs() {
        return [
          {name: 'projects', path: 'projects'},
          {
            name: 'projectDetail', path: {
              name: 'projectDetail',
              params: {projectId: this.$route.params.projectId}
            }
          },
          {name: 'editSpending'}
        ]
      }
    }
  }
</script>